export default "__VITE_ASSET__65M0$uM7__"